const ButtonOptions = ({
  withIconButton = false,
  titleButton = "",
  iconButton = <></>,
  onClickButton = () => {},
  colorButton = "primary",
  labelTitle = "Sin titulo",
  fontSize = 12
}) => {
  //** Colores botón
  // Primary: Azúl
  // Secondary: Gris
  // Warning: Amarillo
  // Danger: Rojo */
  return (
    <button onClick={onClickButton} className={`btn btn-sm btn-${colorButton}`} title={labelTitle} style={{ fontSize: fontSize }}>
      {withIconButton ? iconButton : titleButton}
    </button>
  );
};

export default ButtonOptions;
